import React from 'react';

type PageShellVariant = 'page' | 'content';

interface PageShellProps {
  variant: PageShellVariant;
  children: React.ReactNode;
}

const PageShell: React.FC<PageShellProps> = ({ variant, children }) => {
  if (variant === 'content') {
    return (
      <div className="content-container">
        <div className="content-card">{children}</div>
      </div>
    );
  }

  return <div className="page-container">{children}</div>;
};

export default PageShell;
